import React from 'react'
import { Table, DateTimeUtils, EllipsisDropdown, Icon, ControlledPopup, ClippedContent, STATUS_TYPES, Notification, CollapsibleList } from 'dyl-components';
import { Dropdown, Header, Popup } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import tcrConfig from 'actions/tcr';
import { PhoneUtil } from 'utils';
import RestrictedView from 'shared/RestrictedView';
import { USER_PERMISSIONS } from 'dyl-components';

export default function CampaignRegistrationRow({ campaign, onRowClick }) {
  const dispatch = useDispatch();
  const getStatus = (status) => {
    switch (status) {
      case 'PENDING':
        return <span className='BrandRegistrationForm__Status BrandRegistrationForm__Status--pending' >Pending Approval</span>;
      case 'ACCEPTED':
        return <span className='BrandRegistrationForm__Status BrandRegistrationForm__Status--active' >Verified</span>;
      case 'DECLINED':
        return <span className='BrandRegistrationForm__Status BrandRegistrationForm__Status--rejected' >Declined</span>;
      default:
        return <span className='BrandRegistrationForm__Status' style={{ fontWeight: 'normal' }}>None</span>
    }
  }

  const getTCRStatus = (status) => {
    switch (status) {
      case 'ACTIVE':
        return <span className='BrandRegistrationForm__Status BrandRegistrationForm__Status--active' >Active</span>;
      case 'INACTIVE':
        return <span className='BrandRegistrationForm__Status BrandRegistrationForm__Status--rejected' >Inactive</span>;
      case 'SUSPENDED':
        return <span className='BrandRegistrationForm__Status BrandRegistrationForm__Status--pending' >Suspended</span>;
      case 'EXPIRED':
        return <span className='BrandRegistrationForm__Status BrandRegistrationForm__Status--rejected' >Expired</span>;
      default:
        return <span className='BrandRegistrationForm__Status' style={{ fontWeight: 'normal' }}>None</span>
    }
  }
  const onEditCampaign = async ()=>{
    await dispatch(tcrConfig.getBrandCampaign(campaign.id));
    onRowClick();
  }

  const onDeleteCampaign = async ()=>{
    try {
      await dispatch(tcrConfig.deleteBrandCampaign(campaign.id,undefined,undefined,undefined,{
       tcr_campaign_id : campaign.campaign_id,
      }));
      await dispatch(tcrConfig.getBrandCampaigns());
      Notification.alert(`Campaign deleted successfully`, STATUS_TYPES.SUCCESS);
    } catch (error) {
      Notification.alert(`Campaign deleted failed`, STATUS_TYPES.ERROR);
    }

  }
  return (
    <React.Fragment>
    <Table.Row>
      <Table.Cell disabled={campaign?.tcr_status === "EXPIRED"}>
        {campaign?.created && (
          <>
            <div><b>{DateTimeUtils.formatEpoch(campaign.created, DateTimeUtils.WORD_DATE_FORMAT)}</b></div>
            <div>{DateTimeUtils.formatEpoch(campaign.created, DateTimeUtils.TIME_FORMAT)}</div>
          </>
        )}
      </Table.Cell>
      <Table.Cell disabled={campaign?.tcr_status === "EXPIRED"}>
        {campaign?.registered && (
          <>
            <div><b>{DateTimeUtils.formatEpoch(campaign.registered, DateTimeUtils.WORD_DATE_FORMAT)}</b></div>
            <div>{DateTimeUtils.formatEpoch(campaign.registered, DateTimeUtils.TIME_FORMAT)}</div>
          </>
        )}
      </Table.Cell>
      <Table.Cell disabled={campaign?.tcr_status === "EXPIRED"}>
        {campaign?.nextRenewalOrExpirationDate && ( 
          <>
            <div><b>{DateTimeUtils.changeFormat(campaign.nextRenewalOrExpirationDate, DateTimeUtils.CALENDAR_API_DATE_FORMAT, DateTimeUtils.WORD_DATE_FORMAT)}</b></div>
            <div>{DateTimeUtils.changeFormat(campaign.nextRenewalOrExpirationDate, DateTimeUtils.CALENDAR_API_DATE_FORMAT, DateTimeUtils.TIME_FORMAT)}</div>
          </>
        )}
        </Table.Cell>
        <Table.Cell className="CampaignRegistrationTable__MediumFixedWidth" width={2} style={{ display: "flex", alignItems: "center" }}>

          <Popup
            trigger={<Icon className={`fas ${campaign?.high ? "fa-arrow-up" : "fa-arrow-down"}`} color="primary" />}
            content={campaign?.high ? "High Volume" : "Low Volume"}
            position="top center"
            inverted />
          <ClippedContent popupContent={campaign?.name}>

            {campaign?.name}
          </ClippedContent>
        </Table.Cell>
      <Table.Cell disabled={campaign?.tcr_status === "EXPIRED"}>
        {campaign?.campaign_id}
      </Table.Cell>
      <Table.Cell disabled={campaign?.tcr_status === "EXPIRED"}>
        <CollapsibleList 
          items={campaign?.phone?.map(phone => (PhoneUtil.formatPhoneNumber(phone))) || []}
        />
      </Table.Cell>
      <Table.Cell>
        <Header as='h4'>{getStatus(campaign?.status)}</Header>
      </Table.Cell>
      <Table.Cell>
        <Header as='h4'>{getTCRStatus(campaign?.tcr_status)}</Header>
      </Table.Cell>
      <Table.Cell>
        <EllipsisDropdown disabled={campaign?.tcr_status === "EXPIRED"}>
          <RestrictedView type="disabled" userPermission={USER_PERMISSIONS.CAMPAIGN_REGISTRATION_EDIT}>
            <Dropdown.Item
              onClick={onEditCampaign}
              disabled={campaign?.tcr_status === "EXPIRED"}
              text={<React.Fragment>
                <Icon name='pencil' />
                Edit
              </React.Fragment>}
              style={{ cursor: 'pointer' }} />
            </RestrictedView>
            <RestrictedView type="controlledPopupDisabled" userPermission={USER_PERMISSIONS.CAMPAIGN_REGISTRATION_DELETE}>
              <ControlledPopup
                trigger={
                  <Dropdown.Item
                    disabled={campaign?.tcr_status === "EXPIRED"}
                    text={<React.Fragment>
                      <Icon name='trash' />
                      {campaign?.campaign_id ? `Permanently Delete` : "Delete"}
                    </React.Fragment>}
                    style={{ cursor: 'pointer' }} />
                }
                header={
                  <Header as="h4" textAlign="center">
                    Are you sure?
                    {campaign?.campaign_id && <Header.Subheader style={{ marginTop: 5 }}>
                      This will permanently delete the campaign from TCR.
                    </Header.Subheader>}
                  </Header>
                }
                onConfirm={onDeleteCampaign}
                inverted
              />
            </RestrictedView>
        </EllipsisDropdown>
      </Table.Cell>
    </Table.Row>
    </React.Fragment>
  )
}
